export default "__VITE_ASSET__Dn0rYxph__"